import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

import { getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { WidgetConfiguration, WidgetConfigurationsService } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { mapWherePropertiesMatch } from '@common/index';

@Injectable({
  providedIn: 'root'
})
export class ManagerDetailsWidgetAdminHandler implements WidgetAdminHandler {

  constructor(private readonly widgetConfigService: WidgetConfigurationsService) { }

  initialise(): boolean {
    return true;
  }

  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition {
    return getDefaultWidgetConfigAdminForm(selectedConfig);
  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);
    this.mapSelectedManagerCodesToConfig(copyOfSelectedConfig, adminFormValue);
    return this.widgetConfigService.createcopy(copyOfSelectedConfig).pipe(
      map(() => true)
    );
  }

  private mapSelectedManagerCodesToConfig(config: WidgetConfiguration, adminFormValue: any) {
    if (adminFormValue.selectedManagerCodes) {
      config.selectedManagerCodes = adminFormValue.selectedManagerCodes.map(x => {
        return x.Code;
      });
    }
  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);
    this.mapSelectedManagerCodesToConfig(copyOfSelectedConfig, adminFormValue);
    return this.widgetConfigService.save(copyOfSelectedConfig).pipe(
      map(() => true)
    );
  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    const copyOfSelectedConfig: WidgetConfiguration = mapWherePropertiesMatch(selectedConfig, adminFormValue);
    this.mapSelectedManagerCodesToConfig(copyOfSelectedConfig, adminFormValue);
    return this.widgetConfigService.delete(copyOfSelectedConfig).pipe(
      map(() => true)
    );
  }
}



